export const COLOR_PICKER_MODES = {
	SOLID: {VALUE: 'solid', NAME: 'Solid', TYPE: 'solid'},
	LINEAR: {VALUE: 'linear', NAME: 'Linear Gradient', TYPE: 'linear-gradient'},
	RADIAL: {VALUE: 'radial', NAME: 'Radial Gradient', TYPE: 'radial-gradient'}
}
